import { useMemo } from "react";

import { generateBranchUrl } from "utils/urls";
import { Stack } from "types/generated";
import TableCellSimple from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellBranch from "ds/components/Table/Row/CellBranch";
import { StackSuggestions } from "constants/stack";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const StacksTableBranchCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const branchFilterAction = useCellFilterAction({
    filterName: StackSuggestions.Branch,
    filterValue: stack.branch,
  });

  const actions = useMemo(() => [branchFilterAction], [branchFilterAction]);

  return (
    <TableCellSimple {...cellProps} actions={actions}>
      {!stack.apiHost && <TableCellEmpty />}

      {stack.apiHost && (
        <TableCellBranch
          href={generateBranchUrl({
            apiHost: stack.apiHost!,
            namespace: stack.namespace,
            repository: stack.repository,
            repositoryURL: stack.repositoryURL || "",
            provider: stack.provider,
            branch: stack.branch,
          })}
          onPress={() => trackAnalytics("Branch link clicked")}
        >
          {stack.branch}
        </TableCellBranch>
      )}
    </TableCellSimple>
  );
};

export default StacksTableBranchCell;
